import PropTypes from 'prop-types';
import React from 'react';
import { Carousel, Image, Modal } from 'react-bootstrap';

function formatCarouselPhotos(photos) {
  const photoList = [];
  photos.forEach(photo => {
    if (photo.photo) {
      photoList.push(
        <Carousel.Item key={photo.id}>
          <Image src={photo.photo} responsive className="hotel-img" />
          <Carousel.Caption>
            <h1 className="carousel-caption">{photo.name}</h1>
          </Carousel.Caption>
        </Carousel.Item>
      );
    } else {
      photoList.push(
        <Carousel.Item key={photo.id}>
          <div className="caption">
            <h4>Error missing URL for photo {photo.name}</h4>
          </div>
        </Carousel.Item>
      );
    }
  });
  return photoList;
}

class PhotosModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = { show: false };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(idx) {
    this.setState({ show: true, idx });
  }

  render() {
    const idx = this.state.idx;
    const photos = formatCarouselPhotos(this.props.photos);
    return (
      <div>
        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName="hotel-photos-modal"
        >
          <Modal.Body>
            <Carousel
              indicators={false}
              interval={null}
              prevIcon={<i className="fa fa-chevron-left hotel-carousel-control left" />}
              nextIcon={<i className="fa fa-chevron-right hotel-carousel-control right" />}
              defaultActiveIndex={idx}
            >
              {photos}
            </Carousel>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default PhotosModal;



// WEBPACK FOOTER //
// src/routes/hotels/components/PhotosModal.js